import useGetApi from 'src/api/useGetApi';

export const EMAIL_INGEST_QUERY_KEY = 'organization/config/email-ingest';

export interface EmailIngestConfig {
  enabled: boolean;
  tenantId: string | null;
  clientId: string | null;
  hasClientSecret: boolean;
  clientSecretExpiresAt: string | null;
  mailboxUpns: string[];
  webhookStatus?: WebhookStatus;
}

export interface WebhookStatus {
  isActive: boolean;
  subscriptions: Array<{
    mailboxUpn: string;
    subscriptionId: string;
    expirationDateTime: string;
  }>;
  lastChecked: Date;
}

type ApiResponse = {
  emailIngestConfig: EmailIngestConfig;
};

function parseDate(value: unknown): Date | null {
  if (value instanceof Date) return value;
  if (typeof value === 'string' || typeof value === 'number') {
    const d = new Date(value);
    return Number.isNaN(d.getTime()) ? null : d;
  }
  return null;
}

const useEmailIngestConfig = () => {
  return useGetApi<ApiResponse, ApiResponse>({
    endpoint: 'organization/config/email-ingest',
    queryKey: [EMAIL_INGEST_QUERY_KEY],
    transformResponse: (data) => {
      const ws = data.emailIngestConfig.webhookStatus;
      return {
        emailIngestConfig: {
          ...data.emailIngestConfig,
          webhookStatus: ws
            ? {
                ...ws,
                lastChecked: parseDate(ws.lastChecked) ?? new Date(),
              }
            : undefined,
        },
      };
    },
  });
};

export default useEmailIngestConfig;
